import { render } from "./CommonInstitutional.vue?vue&type=template&id=533afbbc"
import script from "./CommonInstitutional.vue?vue&type=script&lang=js"
export * from "./CommonInstitutional.vue?vue&type=script&lang=js"

import "./CommonInstitutional.vue?vue&type=style&index=0&id=533afbbc&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__